export default "__VITE_ASSET__Byxd2BIs__"